import { render, staticRenderFns } from "./EditAreaInfo.vue?vue&type=template&id=4d498317"
import script from "./EditAreaInfo.vue?vue&type=script&lang=js"
export * from "./EditAreaInfo.vue?vue&type=script&lang=js"
import style0 from "./EditAreaInfo.vue?vue&type=style&index=0&id=4d498317&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports